import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { DateFormatPipe, MomentModule } from 'ngx-moment';

import { environment } from 'src/environments/environment';

import { BaseComponent } from './components/base/base.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

import { SafePipe } from './pipes/safe.pipe';

import { DragAndDropDirective } from './directives/drag-and-drop.directive';

import { ModalDocumentsMissingComponent } from './modals/modal-documents-missing/modal-documents-missing.component';
import { ModalPaymentSuccessComponent } from './modals/modal-payment-success/modal-payment-success.component';
import { ModalVideoComponent } from './modals/modal-video/modal-video.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    AngularSvgIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTabsModule,
    MatRadioModule,
    MatDialogModule,
    MatAutocompleteModule,
  ],
  declarations: [
    NotFoundComponent,
    ModalDocumentsMissingComponent,
    DragAndDropDirective,
    BaseComponent,
    ModalVideoComponent,
    ModalPaymentSuccessComponent,
    SafePipe,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: environment.locale }, DateFormatPipe],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    AngularSvgIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTabsModule,
    MatRadioModule,
    MatDialogModule,
    DragAndDropDirective,
    MatAutocompleteModule,
  ],
})
export class SharedModule {}
